import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbCollapseModule, NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';


// Component pages

import { StudentFooterComponent } from './footer/student-footer.component';
import { LoadingBarModule } from './../../core/loading-bar/loading-bar.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReplacePipe } from 'src/app/dashboard/services/replace';
import { SafeHtmlPipe } from 'src/app/dashboard/services/safe.html';
import { StudentTopbarComponent } from './topbar/student-topbar.component';
import { StudentLayoutComponent } from './student-layout.component';

const routes: Routes = [
  {
    path: '',
    component: StudentLayoutComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('../student-dashboard/student-dashboard.module').then(m => m.StudentDashboardModule)
       },
    //   {
    //     path: 'courses', // Route for the list of all student courses
    //     loadChildren: () => import('../student-courses/student-courses.module').then(m => m.StudentCoursesModule)
    //  },
      // Example: Route for a single course detail view (could be part of StudentCoursesModule or its own)
      // {
      //   path: 'course/:courseId', // The :courseId parameter
      //   loadChildren: () => import('../student-course-detail/student-course-detail.module').then(m => m.StudentCourseDetailModule)
      // },
      // Example for other student features:
      // {
      //   path: 'profile',
      //   loadChildren: () => import('../student-profile/student-profile.module').then(m => m.StudentProfileModule)
      // },
      // {
      //   path: 'grades',
      //   loadChildren: () => import('../student-grades/student-grades.module').then(m => m.StudentGradesModule)
      // },
      // {
      //   path: 'settings',
      //   loadChildren: () => import('../student-settings/student-settings.module').then(m => m.StudentSettingsModule)
      // },
      // {
      //   path: 'notifications', // For a dedicated notifications page
      //   loadChildren: () => import('../student-notifications/student-notifications.module').then(m => m.StudentNotificationsModule)
      // }
    ]
  }
];

@NgModule({
  declarations: [
    StudentLayoutComponent,
    StudentTopbarComponent,
    StudentFooterComponent
  ],
  imports: [
        CommonModule,
        RouterModule.forChild(routes),
        NgbCollapseModule,
        NgbDropdownModule,
        NgbNavModule,
        SimplebarAngularModule,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule,
        LoadingBarModule,
        ReplacePipe,
        SafeHtmlPipe,
        NgSelectModule
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class StudentLayoutModule { }
